export const FYND_WHITE = `
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    >
    <rect x="0" y="0" width="100" height="100" fill="#2ED3B7" />
    <path
        d="M30 25
        Q30 20 35 20
        H65
        Q70 20 70 25
        Q70 30 65 30
        H40
        V75
        Q40 80 35 80
        Q30 80 30 75
        Z"
        fill="#f8eaeaff"
    />
    <circle cx="58" cy="52" r="7" fill="#f8eaeaff" />
    </svg>
`;
